const STORAGE_KEY = "__sf_rate_limit";

interface RateLimitBucket {
  tokens: number;
  lastRefill: number;
}

export function checkRateLimit(
  action: string,
  maxTokens = 5,
  windowMs = 60000,
): { allowed: boolean; retryAfter: number } {
  const key = `${STORAGE_KEY}_${action}`;
  const now = Date.now();
  let bucket: RateLimitBucket;

  try {
    const raw = localStorage.getItem(key);
    bucket = raw ? JSON.parse(raw) : { tokens: maxTokens, lastRefill: now };
  } catch {
    bucket = { tokens: maxTokens, lastRefill: now };
  }

  const elapsed = now - bucket.lastRefill;
  const refillTokens = Math.floor(elapsed * (maxTokens / windowMs));
  bucket.tokens = Math.min(maxTokens, bucket.tokens + refillTokens);
  bucket.lastRefill = now;

  if (bucket.tokens >= 1) {
    bucket.tokens -= 1;
    try {
      localStorage.setItem(key, JSON.stringify(bucket));
    } catch {
      /* graceful degradation */
    }
    return { allowed: true, retryAfter: 0 };
  }

  const retryAfter = Math.ceil((windowMs - (elapsed % windowMs)) / 1000);
  return { allowed: false, retryAfter };
}
